let u = navigator.userAgent;
// let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
let mobile = !!u.match(/AppleWebKit.*Mobile.*/);
const state = {
  user_agent: mobile,
  isiOS:isiOS
};
const getters = {
    user_agent: state => state.user_agent,
	isiOS:state => state.isiOS,
};
const mutations = {};
const actions = {};
export default {
  state,
  getters,
  mutations,
  actions
};
